import { sidebarVisible, sidebarHidden } from '../LeftPane.scss';

/**
 * Returns correct styling behavior for rendering left pane
 */

export const useLeftPaneContentStyle = (showLeftPane: boolean): string => {
    if (showLeftPane) {
        return sidebarVisible;
    }
    return sidebarHidden;
};
